module.exports = __webpack_public_path__ + "img/MU.f79feea8.svg";